import { render, staticRenderFns } from "./FreshChatAdmin.vue?vue&type=template&id=b15f0a3c&scoped=true"
import script from "./FreshChatAdmin.vue?vue&type=script&lang=js"
export * from "./FreshChatAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15f0a3c",
  null
  
)

export default component.exports